import { Box } from '@mui/system';
import { StyledLocoBingo } from './style';
import { BundleProps } from '../types';
import BundlePrice from '../BundlePrice';
import { EBadgeType, EBundlesInternalViewModel } from '../../Helper/enums';
import { useEffect, useState } from 'react';
import { BadgeData } from '../../Badge/types';
import LocoBingoSaleBadge from '../../Badge/Sale/LocoBingoSaleBadge';

function Bundle({
    price,
    productList,
    badges = [],
    backgroundSrc,
    backgroundColor = { colorOne: '#880000' },
    salePercentage = 0,
    borderRadius,
    salePercentageDisplayType
}: BundleProps) {
    const [ribbonBadge, setRibbonBadge] = useState<any>(null);

    useEffect(() => {
        let foundRibbon;
        if (badges.length > 0) {
            if (badges[0].badge) {
                foundRibbon = badges?.find(
                    (badge: BadgeData) =>
                        (badge as BadgeData).badge?.type === EBadgeType.RIBBON
                )?.badge as BadgeData;
                setRibbonBadge(foundRibbon?.ribbon);
            } else {
                foundRibbon = badges?.find(
                    (badge: BadgeData) => badge.type === EBadgeType.RIBBON
                );
                setRibbonBadge(foundRibbon?.ribbon);
            }
        }
    }, [badges]);

    return (
        <StyledLocoBingo
            direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
            marginRight={
                price.spacing && price.symbolPosition === 'Left' ? '4px' : '0px'
            }
            marginLeft={
                price.spacing && price.symbolPosition === 'Right'
                    ? '4px'
                    : '0px'
            }
            productColor={
                productList.length > 0 ? productList[0].textFontColorHex : ''
            }
            backgroundSrc={backgroundSrc}
            backgroundColor={backgroundColor}
            className="internal-bundle"
            isSale={!!salePercentage}
            borderRadius={borderRadius}
            ribbonTextColor={ribbonBadge ? ribbonBadge.textColor : '#fff'}
            ribbonBackgroundColor={
                ribbonBadge ? ribbonBadge.backgroundColor : '#F71B06'
            }
            style={{ width: '100%', height: '100%' }}
            productBackground={
                productList.length > 0
                    ? `url(${productList[0].images.product})`
                    : ''
            }
        >
            <Box className="container">
                {salePercentage > 0 && (
                    <LocoBingoSaleBadge
                        salePercentage={salePercentage}
                        salePercentageDisplayType={salePercentageDisplayType}
                    />
                )}
                <Box className="product">
                    {productList.length > 0 && (
                        <Box>
                            <Box className="amount">
                                {salePercentage > 0 && (
                                    <Box className="stroked">
                                        {productList[0].strokedSaleQuantity}
                                    </Box>
                                )}
                                <Box>
                                    {productList[0].images.productPrefix && (
                                        <img
                                            src={
                                                productList[0].images
                                                    .productPrefix
                                            }
                                            alt="coin"
                                        />
                                    )}
                                    {productList[0].quantityDisplay}
                                </Box>
                            </Box>
                            <Box className="image-container" />
                        </Box>
                    )}
                    <Box
                        className="price-container"
                        style={{
                            marginTop: productList.length > 0 ? 0 : 'auto'
                        }}
                    >
                        <BundlePrice
                            price={price}
                            type={EBundlesInternalViewModel.LOCO_BINGO}
                        />
                    </Box>
                </Box>
                {ribbonBadge && (
                    <Box className="ribbon">
                        <div className="ribbon__text">{ribbonBadge.text}</div>
                    </Box>
                )}
            </Box>
        </StyledLocoBingo>
    );
}

export default Bundle;
